//Generic fixed variables

export enum DEBUG_MODE {
    OFF = 0,
    ERROR = 1,
    WARNING = 2,
    NOTICE = 3,
    N_COLOR = '#c3efed',
    W_COLOR = '#c0b721',
    E_COLOR = '#c53e3e',
}

export const DEFAULT_PERIOD = 'day';
export const DEFAULT_N_OF_PERIOD = '7';
export const DEFAULT_COUNTRY = '';

export const EMAIL_VALIDATION = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SPINNER_DURATION = 1000;

export const PERIOD_FILTERS = [
    { label: 'Ultima settimana', period: 'day', n_period: '7' },
    { label: 'Ultime 2 settimane', period: 'day', n_period: '14' },
    { label: 'Ultimi 3 mesi', period: 'week', n_period: '12' },
    { label: 'Ultimi 6 mesi', period: 'month', n_period: '6' },
    { label: 'Ultimo anno', period: 'month', n_period: '12' },
];

export const LANG_LABELS = [{value: 'ITA', label: 'ITALIANO'}, {value: 'ENG', label: 'ENGLISH'}];

export const AV_LANGUAGES = [
    'ar-SA',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'el-GR',
    'en-GB',
    'es-ES',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'ja-JP',
    'ko-KR',
    'nl-NL',
    'no-NO',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'zh-CN',
    'it-IT',
];

export const BREAKPOINT_MOB_MIN_WIDTH = 360; //included
export const BREAKPOINT_MOB_MAX_WIDTH = 767; //included
export const BREAKPOINT_TAB_MIN_WIDTH = 768; //included
export const BREAKPOINT_TAB_MAX_WIDTH = 991; //included
export const BREAKPOINT_DSK_MIN_WIDTH = 992; //included